import React from "react"

import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"

import Paper from "@material-ui/core/Paper"

import {
  VeglisteData,
  VeglisteHeaderCells,
} from "../../interfaces/Vegliste.interface"

import tw from "twin.macro"

interface SimpleTableHeadProps {
  headerCells: Array<VeglisteHeaderCells>
}

interface SimpleTableProps {
  headerCells: Array<VeglisteHeaderCells>
  rows: Array<VeglisteData>
  tableTitle: string
  className?: string
}

const SimpleTable: React.FunctionComponent<SimpleTableProps> = props => {
  return (
    <Paper style={tw`my-8`}>
      <h2 style={tw`text-xl mx-2 py-4 font-bold`}>{props.tableTitle}</h2>
      <Table>
        <EnhancedTableHead headerCells={props.headerCells} />
        <TableBody>
          {props.rows.map((row, index) => {
            return (
              <TableRow key={index}>
                <TableCell tw="text-lg" align="left">
                  {row.veg}
                </TableCell>
                <TableCell align="left">{row.vegstrekning}</TableCell>
                <TableCell align="left">{row.veglengde}</TableCell>
                <TableCell align="left">{row.totalvekt}</TableCell>
                <TableCell align="left">{row.tillattVogntoglengde}</TableCell>
                <TableCell align="left">{row.linkmodulevogntog}</TableCell>
                <TableCell align="left">{row.vinterMaks}</TableCell>
                <TableCell align="left">{row.merknad}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </Paper>
  )
}

function EnhancedTableHead(props: SimpleTableHeadProps) {
  const { headerCells } = props

  return (
    <TableHead>
      <TableRow>
        {headerCells.map(headCell => (
          <TableCell key={headCell.id} align="left" style={tw`font-bold`}>
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

export default SimpleTable
